/**
 * Nachhaltiger Wohnen - Kleine Schritte für eine große Veränderung
 *
 * Carried over from the old WordPress site, word for word. `legacyImage` records
 * the photograph the article used; every one of those files 404s from the origin
 * server, so nothing references them - the field exists so the pictures can be
 * wired back up if they ever turn up in a backup. Until then components/Cover.jsx
 * draws a cover from the slug.
 */
export const meta = {
  slug: 'nachhaltiger-wohnen-kleine-schritte-fuer-eine-grosse-veraenderung',
  title: 'Nachhaltiger Wohnen - Kleine Schritte für eine große Veränderung',
  date: '2023-12-17',
  category: 'Nachhaltigkeit',
  excerpt:
    'Nachhaltiges Wohnen erfordert keine radikalen Veränderungen. Zehn Ansätze, mit denen Sie im eigenen Zuhause anfangen können.',
  /** Reading time, stated rather than counted: the body is markup now. */
  minutes: 2,
  legacyImage: 'farmer-hand-holding-young-plant-top-view-banner-2023-11-27-04-57-17-utc-scaled.jpg',
  legacyAlt: 'Farmer hand holding young plant. New life, eco, sustainable living concept.',
}

export default function Article() {
  return (
    <>
      <p>
        In einer Zeit, in der Umweltbewusstsein immer wichtiger wird, suchen
        immer mehr Menschen nach Möglichkeiten, nachhaltiger zu leben - und
        das Zuhause ist ein ausgezeichneter Ort, um anzufangen. In diesem
        Blogartikel erkunden wir, wie wir durch einfache, aber wirkungsvolle
        Änderungen nachhaltiger wohnen können.
      </p>
      <ol>
        <li>
          <strong>Umweltfreundliche Möbel und Materialien:</strong> Beginnen
          Sie Ihr nachhaltiges Wohnabenteuer mit umweltfreundlichen Möbeln
          und Materialien. Entscheiden Sie sich für recycelte,
          wiederverwendete oder nachhaltig gewonnene Holzarten. Achten Sie
          auf Gütesiegel und Zertifizierungen, die umweltfreundliche
          Produktionspraktiken garantieren.
        </li>
        <li>
          <strong>Energiesparende Beleuchtung:</strong> Tauschen Sie
          herkömmliche Glühbirnen gegen energieeffiziente LED-Lampen aus.
          Diese verbrauchen weniger Energie, haben eine längere Lebensdauer
          und tragen somit zur Reduzierung des CO2-Fußabdrucks bei.
        </li>
        <li>
          <strong>Wasser sparen im Haushalt:</strong> Installieren Sie
          wassersparende Armaturen und Duschköpfe, um den Wasserverbrauch zu
          reduzieren. Reparieren Sie undichte Wasserhähne sofort, um
          unnötige Verschwendung zu vermeiden.
        </li>
        <li>
          <strong>Recycling-Station im Haus:</strong> Richten Sie eine
          Recycling-Station in Ihrer Küche oder einem anderen zugänglichen
          Bereich ein. Trennen Sie Papier, Plastik, Glas und Metall, um
          sicherzustellen, dass Ihre Abfälle effizient recycelt werden.
        </li>
        <li>
          <strong>Indoor-Pflanzen für bessere Luftqualität:</strong> Fügen
          Sie Ihrem Zuhause grüne Akzente hinzu, indem Sie luftreinigende
          Zimmerpflanzen platzieren. Pflanzen wie die Friedenslilie oder der
          Gummibaum helfen nicht nur, die Luft zu reinigen, sondern schaffen
          auch eine angenehme Atmosphäre.
        </li>
        <li>
          <strong>Nachhaltige Reinigungsmittel:</strong> Ersetzen Sie
          herkömmliche Reinigungsmittel durch umweltfreundliche
          Alternativen. Essig, Natron und Zitronensaft sind effektive,
          natürliche Reinigungsmittel, die Ihre Wohnung frisch und sauber
          halten.
        </li>
        <li>
          <strong>Upcycling und Do-It-Yourself-Projekte:</strong> Statt neue
          Möbel zu kaufen, probieren Sie Upcycling und DIY-Projekte aus.
          Verwandeln Sie alte Gegenstände in neue Schätze und geben Sie
          ihnen einen zweiten Lebenszyklus.
        </li>
        <li>
          <strong>Weniger ist mehr:</strong> Praktizieren Sie bewussten
          Konsum, indem Sie nur das kaufen, was Sie wirklich benötigen.
          Hochwertige, langlebige Produkte haben oft einen geringeren
          ökologischen Fußabdruck als billige Einwegartikel.
        </li>
        <li>
          <strong>Stromsparende Geräte:</strong> Bei Neuanschaffungen von
          Elektrogeräten achten Sie auf energieeffiziente Modelle. Diese
          tragen nicht nur zur Umweltfreundlichkeit bei, sondern können auch
          langfristig Ihre Energiekosten senken.
        </li>
        <li>
          <strong>Transportmittel überdenken:</strong> Betrachten Sie
          nachhaltige Alternativen für Ihren täglichen Weg zur Arbeit, wie
          das Fahrrad oder den öffentlichen Nahverkehr. Reduzieren Sie Ihre
          CO2-Emissionen, indem Sie auf umweltfreundliche Transportmittel
          setzen.
        </li>
      </ol>
      <h2>Fazit</h2>
      <p>
        Nachhaltiges Wohnen erfordert keine radikalen Veränderungen, sondern
        beginnt mit kleinen Schritten. Jede bewusste Entscheidung, die wir
        in unseren Wohnungen treffen, hat eine positive Auswirkung auf die
        Umwelt. Lassen Sie uns gemeinsam daran arbeiten, unsere Häuser zu
        grüneren, umweltfreundlicheren Orten zu machen - für eine
        nachhaltigere Zukunft.
      </p>
    </>
  )
}
